/*
 * @Description: xxx
 * @version: 1.0
 * @Author: 3hljk
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import $ from 'jquery'
import 'element-ui/lib/theme-chalk/index.css'
import VueWorker from 'vue-worker' // Web worker插件

import { Checkbox, Card, Alert, CheckboxGroup, CheckboxButton, TabPane, Timeline, TimelineItem, Image, Tabs, Notification, MessageBox, Drawer, Dialog, Button, ColorPicker, Progress } from 'element-ui';

window.jQuery = $
window.$ = $
Vue.config.productionTip = false

Vue.use(Checkbox)
Vue.use(Card)
Vue.use(Alert)
Vue.use(CheckboxGroup)
Vue.use(CheckboxButton)
Vue.use(TabPane)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Image)
Vue.use(Tabs)
Vue.use(Drawer)
Vue.use(Dialog)
Vue.use(Button)
Vue.use(ColorPicker)
Vue.use(Progress)
Vue.prototype.$notify = Notification;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$prompt = MessageBox.prompt;

Vue.use(VueWorker)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
